import React, { useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';
import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../store';
import { IEventEnrollment } from '../../../../store/admin/eventEnrollments/store';

import Input from '../../../../components/Input';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { getEnrollmentsByFlight } from './Utils/getEnrollmentsByFlight';
import { FlightsSectionSelector } from './Components/FlightsSectionSelector';
import { IndividualFlights } from './Components/IndividualFlights';
import { TeamsFlights } from './Components/TeamsFlights';
import { TeamsCreatorProvider } from '../TeamsCreator/Context/TeamsCreator.context';
import { TeeSheetCreatorProvider } from '../TeeSheetCreator/Context/TeeSheetCreator.context';

export interface IByFlight {
  [flightId: number]: {
    enrollments: IEventEnrollment[];
    expanded: boolean;
  };
}

interface IProps {
  clubId: string;
  eventId: string;
  roundId: string;
}

export const INDIVIDUAL_SECTION = 'INDIVIDUAL';
export const TEAMS_SECTION = 'TEAMS';

export type TSection = typeof INDIVIDUAL_SECTION | typeof TEAMS_SECTION;

const RoundFlights = (props: IProps) => {
  const { clubId, eventId, roundId } = props;

  const { actions, adminEventEnrollments, adminRoundFormats } = useContext(GlobalContext);

  const [searchValue, setSearch] = useState('');
  const [openFlights, setOpenFlights] = useState<IByFlight>({});
  const [flightsSection, setFlightsSection] = useState<TSection>(INDIVIDUAL_SECTION);

  const enrollments = adminEventEnrollments[Number(eventId)] || [];

  useEffect(() => {
    if (roundId) {
      const eventRoundFormats = adminRoundFormats[Number(roundId)];

      if (eventRoundFormats) {
        const displayFlightsForIndividuals = eventRoundFormats.some(format => !format.format.teams);

        if (!displayFlightsForIndividuals) {
          setFlightsSection(TEAMS_SECTION);
        }
      }
    }
  }, [adminRoundFormats, eventId]);

  useEffect(() => {
    if (clubId && eventId) {
      actions.adminEventEnrollments.get(Number(clubId), Number(eventId));
    }
  }, [eventId]);

  const onContinue = () =>
    navigate(`/staff/club/${clubId}/event/${eventId}/round/${roundId}/launch`);

  const search = async (e: any) => {
    const newOpenFlights = getEnrollmentsByFlight(enrollments, e.target.value);

    setSearch(e.target.value);
    setOpenFlights(newOpenFlights);
  };

  const onSectionClick = (section: TSection) => () => {
    setFlightsSection(section);
  };

  const sections = {
    [INDIVIDUAL_SECTION]: (
      <IndividualFlights
        key="IndividualFlights"
        searchValue={searchValue}
        openFlights={openFlights}
        setOpenFlights={setOpenFlights}
      />
    ),
    [TEAMS_SECTION]: (
      <TeamsCreatorProvider>
        <TeamsFlights />
      </TeamsCreatorProvider>
    )
  };

  return (
    <TeeSheetCreatorProvider>
      <div className="event-wizard-page form">
        <div className="full-width round-flights">
          <EventWizardStepTitle
            buttonText="SAVE & CONTINUE"
            buttonOnClick={onContinue}
            title="ROUND FLIGHTS"
          />

          <Grid container={true} spacing={2} direction="row-reverse">
            <Grid item={true} xs={12} sm={6} md={4}>
              <Input
                id="player-lookup"
                label="PLAYER LOOKUP"
                onChange={search}
                outlined={true}
                placeholder="PLAYER LOOKUP"
                type="search"
              />
            </Grid>
          </Grid>

          <FlightsSectionSelector flightsSection={flightsSection} onSectionClick={onSectionClick} />

          {sections[flightsSection]}
        </div>
      </div>
    </TeeSheetCreatorProvider>
  );
};

export { RoundFlights };
